<template>
  <div class="app">
    <a id="toggle-button" @click="toggleSideNav = !toggleSideNav" :class="toggleSideNav ? 'toggle-left' : 'toggle-right'">
      <i v-if="toggleSideNav === true" class="fa fa-chevron-right"></i>
      <i v-else class="fa fa-chevron-left"></i>
    </a>
    <AppHeader v-if="window.width < 992" fixed>
      <button @click.prevent="toggleSideNav = !toggleSideNav" data-v-58616bf4="" display="md" mobile="true" type="button" class="d-lg-none navbar-toggler"><span class="navbar-toggler-icon"></span></button>
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" ref='clientLogo' src='../../public/img/SOKAL-Final-Color.png' style="width: auto; height: auto; max-width: 155px; max-height: 40px; padding-left: 10px;" alt="Sokal Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="lp-up">
        <li class='nav-item px-3 date-item'>
          <date-range-picker :ranges="range" ref="picker" :startDate="startDate" :endDate="endDate" @update='updateDateRange'>
          &nbsp;
            <div slot="input">
              <input type="text" class="borderless" id="startDate" v-model="startDate"> -
              <input type="text" class="borderless" id="endDate" v-model="endDate">
            </div>

          </date-range-picker>
          <b-form-checkbox v-on:change='toggleCompareDatesCheckbox' v-model="compareDatesCheckbox" value="true" unchecked-value="false" class="compare-checkbox">Compare</b-form-checkbox>
          <date-range-picker :ranges="range" ref="comparePicker" v-if="compareDatesCheckbox === 'true'" :startDate="compareStartDate" :endDate="compareEndDate" @update='updateCompareDateRange'>
            <div slot="input">
              <input type="text" class="borderless" id="compareStartDate" v-model="compareStartDate"> -
              <input type="text" class="borderless" id="compareEndDate" v-model="compareEndDate">
            </div>
          </date-range-picker>
        </li>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto mobile-client d-none d-md-block">
        <li class='nav-item px-3'>
          <v-select :clearable="false" label='name' value='id' placeholder='Select client' :on-change='setCurrentClient' class='select-no-caret' v-model='currentClient' :options="clients" />
          <div id="clientAlert" v-if="this.$route.name === 'Dashboard' && currentClient === null">
            <span>Select a Client</span>
          </div>
        </li>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto mobile-profile">
        <b-nav-item v-b-toggle.date-collapse class="ml-2 lp-down">
          <span class="fa fa-calendar nav-icons"></span>
          <div id="clientAlert" v-if="this.$route.name === 'Dashboard' && currentClient === null">
            <span>Select a Client</span>
          </div>
        </b-nav-item>
        <b-nav-item v-b-toggle.client-collapse class="ml-2 d-md-none">
          <span class="fa fa-address-book-o nav-icons"></span>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div id="tablet-dropdown" class="lp-down">
      <b-collapse id="date-collapse" @show="toggleCollapse('client-collapse')">
        <b-card>
          <date-range-picker class="w-100 text-center" :ranges="range" ref="picker" :startDate="startDate" :endDate="endDate" @update='updateDateRange'>
          &nbsp;
            <div slot="input">
              <input type="text" class="border-input mx-auto" id="startDate" v-model="startDate"> -
              <input type="text" class="border-input mx-auto" id="endDate" v-model="endDate">
            </div>

          </date-range-picker>
          <b-form-checkbox class="d-block text-center" v-on:change='toggleCompareDatesCheckbox' v-model="compareDatesCheckbox" value="true" unchecked-value="false">Compare</b-form-checkbox>
          <date-range-picker class="w-100 text-center" :ranges="range" ref="comparePicker" v-if="compareDatesCheckbox === 'true'" :startDate="compareStartDate" :endDate="compareEndDate" @update='updateCompareDateRange'>
            <div slot="input">
              <input type="text" class="border-input mx-auto" id="compareStartDate" v-model="compareStartDate">
              -
              <input type="text" class="border-input mx-auto" id="compareEndDate" v-model="compareEndDate">
            </div>
          </date-range-picker>
        </b-card>
      </b-collapse>
      <b-collapse id="client-collapse" @show="toggleCollapse('date-collapse')">
        <b-card>
          <v-select :clearable="false" label='name' value='id' placeholder='Select client' :on-change='setCurrentClient' class='select-no-caret m-auto' v-model='currentClient' :options="clients" />
        </b-card>
      </b-collapse>
    </div>
    <div class="app-body">
      <SideNav :clients="clients" :class="{ closed: toggleSideNav }"/>
      <main :class="[ toggleSideNav ? 'closed' : '', 'main']">
        <div class="main-space">
          <b-row class="main-header flex-row" v-show="!customContent">
            <b-col class="col-12">
              <h1 id="dashboard-title">{{ name }}</h1>
              <b-tooltip v-if="isMobile" class="d-md-none" target="dashboard-title">{{ name }}</b-tooltip>
              <div class="edit-btn-container d-none d-md-inline-block">
                <b-button v-if="this.$route.name === 'Dashboards' && currentUser.isDigital" class='edit-btn edit-btn-blue' @click="$eventBus.$emit('newDashboardModal')"  v-b-popover.hover.top="'Create New Dashboard'"><i class="fa fa-plus-circle" aria-hidden="true"></i></b-button>
                <template v-if='this.$route.path.match(/dashboards\//)'>
                  <template v-if="this.currentUser.isDigital">
                    <template v-if="dashboardControlsVisible(this.dashboard)">
                      <b-button class="edit-btn" @click='edit(!addWidgetButtonVisible)' v-b-popover.hover.top="'Edit Dashboard'">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </b-button>
                      <div v-if='addWidgetButtonVisible' class="d-inline">
                        <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="$eventBus.$emit('addWidget')" v-b-popover.hover.top="'Add Widget'"><i class="fa fa-plus-circle" aria-hidden="true"></i></b-button>
                        <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="$eventBus.$emit('addSection')" v-b-popover.hover.top="'Add Section'"><i class="fa fa-plus-square" aria-hidden="true"></i></b-button>
                        <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="$eventBus.$emit('editSections')" v-b-popover.hover.top="'Edit Sections'"><i class="fa fa-pencil-square" aria-hidden="true"></i></b-button>
                      </div>
                    </template>
                    <i v-else class="fa fa-lock" aria-hidden="true"></i>
                  </template>
                  <div v-if='this.$route.path.match(/dashboards\//)' class="d-inline">
                    <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="saveModal('PDF')" v-b-popover.hover.top="'Download PDF'"><i ref='pdfButton' class='fa' :class="pdfButtonClass" aria-hidden="true"></i></b-button>
                    <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="saveModal('XLSX')" v-b-popover.hover.top="'Download XLSX'"><i class="fa fa-file-excel-o" aria-hidden="true"></i></b-button>
                    <b-button class="p1 edit-btn-sm edit-btn-blue" @click="widgetDownload = !widgetDownload" v-b-popover.hover.top="widgetText"><i :class="widgetClass" aria-hidden="true"></i></b-button>
                    <b-button class="p1 edit-btn-sm edit-btn-blue" @click="toggle(!quickDateState)" v-b-popover.hover.top="quickDateText"><i :class="quickDateClass" aria-hidden="true"></i></b-button>
                  </div>
                </template>
              </div>
            </b-col>
          </b-row>
          <div class="container-fluid" id="default-container" :class="{ 'hide-export' : !widgetDownload }">
            <router-view></router-view>
            <help-modal v-if="!currentUser.isDigital"></help-modal>
            <b-modal id="download-modal" :title="`Download ${downloadType}`" hide-footer>
              <b-form @submit="saveDashboard" @reset="buildTitle">
                <div class="row">
                  <b-form-group
                    class="col-sm-12"
                    id="input-download"
                    label="Download Name:"
                    label-for="download"
                    >
                    <b-form-input
                      id="dashboard-download"
                      v-model="downloadTitle"
                      required
                      placeholder="Enter Name"
                      ></b-form-input>
                  </b-form-group>
                </div>
                <div class="mt-3">
                  <b-button type="submit" variant="primary">Download</b-button>
                  <b-button class="ml-2" type="reset">Default Name</b-button>
                </div>
              </b-form>
            </b-modal>
          </div>
        </div>
      </main>
    </div>
    <TheFooter>
      <div class="ml-auto">
        <a href="https://www.gosokal.com" target="_blank">
          <img class="navbar-brand-full" src='../../public/img/SOKAL-Final-Color.png' style="width: auto; height: auto; max-width: 155px; max-height: 30px; padding-left: 10px;" alt="Sokal Logo">
        </a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import SideNav from '@/views/SideNav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside,  Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import HelpModal from '@/views/modals/HelpModal'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import DateRangePicker from 'vue2-daterange-picker'
import vSelect from 'vue-select'
import Moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { dashboardMixins } from '@/shared/DashboardMixins'
import _ from 'lodash'

export default {
  name: 'full',
  mixins: [dashboardMixins],
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DateRangePicker,
    vSelect,
    Moment,
    HelpModal,
    SideNav
  },

  data () {
    return {
      currentClient: {
        name: '',
        id: ''
      },
      compareDatesCheckbox: 'false',
      pdfButtonClass: 'fa-file-pdf-o',
      range: {
        'Today': [Moment(), Moment()],
        'Yesterday': [Moment().subtract(1, 'days'), Moment().subtract(1, 'days')],
        'This month': [Moment().startOf('month'), Moment()],
        'This year': [Moment().startOf('year'), Moment().endOf('year')],
        'Last week': [Moment().subtract(1, 'week').startOf('week'), Moment().subtract(1, 'week').endOf('week')],
        'Last month': [Moment().subtract(1, 'month').startOf('month'), Moment().subtract(1, 'month').endOf('month')],
        'Last 90 Days': [Moment().subtract(90, 'days'), Moment().subtract(1, 'day')],
        'Last year': [Moment().subtract(1, 'year').startOf('year'), Moment().subtract(1, 'year').endOf('year')]
      },
      downloadType: null,
      downloadTitle: '',
      toggleSideNav: false,
      widgetDownload: false,
      customContent: false
    }
  },

  computed: {
    widgetText () {
      return this.widgetDownload ? 'Hide Individual Widget Export Icons' : 'Show Individual Widget Export Icons'
    },
    widgetClass () {
      return this.widgetDownload ? 'fa fa-toggle-on' : 'fa fa-toggle-off'
    },
    quickDateState () {
      return this.$store.getters.quickDateShow
    },
    quickDateText () {
      return this.quickDateState ? 'Hide Quick Date Picker' : 'Show Quick Date Picker'
    },
    quickDateClass() {
      return this.quickDateState ? 'fa fa-toggle-on' : 'fa fa-toggle-off'
    },
    name () {
      return this.$route.name == 'Dashboard' && this.$route.params.id ? this.dashboard.name : this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    startDate: {
      get () {
        return this.$store.getters.startDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setStartDate', value)
      }, 1000)
    },
    endDate: {
      get () {
        return this.$store.getters.endDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setEndDate', value)
      }, 1000)
    },
    compareStartDate: {
      get () {
        return this.$store.getters.compareStartDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setCompareStartDate', value)
      }, 1000)
    },
    compareEndDate: {
      get () {
        return this.$store.getters.compareEndDate
      },
      set: _.debounce(function(value) {
        this.$store.commit('setCompareEndDate', value)
      }, 1000)
    },
    ...mapGetters([
      'dashboards',
      'currentUser',
      'dashboard'
    ]),
    clients () {
      return this.$store.getters.clients.concat(...this.$store.getters.clientGroups)
    },
    addWidgetButtonVisible () {
      return this.$store.getters.widgetSettingsVisible
    },
    navItems () {
      var items = nav.items
      if (!this.currentUser.isDigital){
        items = items.filter((item) => item.name !== "Import data")
      }
      if (this.currentUser && !this.currentUser.isDigital) {
        items = items.filter((item) => ['Dashboards'].includes(item.name))
      }
      return items
    },
    isMobile () {
      return this.window.width < 768
    }
  },

  created () {
    this.loadClientGroups()
    this.loadClients()
    this.getDashboards()
    this.setTempCurrentClient()
  },

  mounted () {
    this.checkClientQuery()
    this.mobileWidget()
    this.checkMobile()
    this.$root.$on('customContent', (visible) => {
      this.customContent = visible
    })
  },

  methods: {
    checkClientQuery () {
      var domain = this.$route.query.domain
      if (domain) {
        setTimeout(()=> {
          var currentClient = this.clients.filter( c => c.domain === domain)
          if (currentClient.length > 0) {
            this.setCurrentClient(currentClient[0])
          }  
        }, 5000)
      }
    },
    nullifyTempClient () {
      if (this.$route.query.temp_client_id){
        let query = Object.assign({}, this.$route.query);
        delete query.temp_client_id;
        this.$router.replace({ query });
      }
    },
    setTempCurrentClient () {
      setTimeout(this.nullifyTempClient, 3000)
      var tempClientId = this.$route.query.temp_client_id
      if (tempClientId){
        this.$http.get('/clients/' + tempClientId + '?temp_client_id=' + tempClientId)
          .then(function(response){
            var client = response.data
            this.$store.commit('setTempCurrentClient', client)
          }.bind(this))
      }
    },
    saveDashboard (e) {
      e.preventDefault()
      this.$eventBus.$emit(`download${this.downloadType}`, this.downloadTitle)
      this.$root.$emit('bv::hide::modal', 'download-modal')
    },
    saveModal (type) {
      this.downloadType = type
      this.buildTitle()
      this.$root.$emit('bv::show::modal', 'download-modal')
    },
    buildTitle () {
      this.currentClient = this.$store.getters.currentClient
      this.downloadTitle = `${this.currentClient.name}_${this.dashboard.name}`
      this.downloadTitle = this.downloadTitle.replace(/\s/g, '')
    },
    toggleCollapse (e) {
      if (document.querySelector(`#${e}`).className.includes('show')) {
        this.$root.$emit('bv::toggle::collapse', e)
      }
    },
    toggleCompareDatesCheckbox () {
      this.compareDatesCheckbox = (this.compareDatesCheckbox === 'true') ? 'false' : 'true'
      var startDate = null
      var endDate = null
      this.$eventBus.$emit('compareDatesEnabled', false)
      if (this.compareDatesCheckbox === 'true'){
        startDate = Moment(this.startDate, 'MMM DD, YYYY').subtract(1, 'month')
        endDate = Moment(this.endDate, 'MMM DD, YYYY').subtract(1, 'month')
        this.$eventBus.$emit('compareDatesEnabled', true)
      }
      this.$store.commit('setCompareStartDate', startDate)
      this.$store.commit('setCompareEndDate', endDate)
      this.$eventBus.$emit('reloadWidgets')
    },

    loadClientGroups () {
      var url = '/client_groups'
      this.$http.get(url)
        .then(function(response){
          var groups = response.data.map( (group) => {
              return {id: group.id, name: group.name + ' (group)', active: group.active}
            }
          )
          this.$store.commit('setClientGroups', groups)
        }.bind(this))
    },

    setCurrentClient (clientObj) {
      if (this.currentClient && this.currentClient.id === clientObj.id) {
        return false;
      }
      this.$store.commit('setCurrentClient', clientObj)
      this.$eventBus.$emit('changeCurrentClient', clientObj)
      this.updateLogo(clientObj)
      this.currentClient = this.$store.getters.currentClient
    },

    loadClients () {
      var url = '/clients'
      if (this.currentUser.isClient && !this.currentUser.isAgency) {
        url += '?dc_user_id=' + this.currentUser.dc_user_id
      }
      this.$http.get(url)
        .then(function(response) {
          this.$store.commit('setClients', response.data)
          let currentClient = this.$store.getters.currentClient
          if (!currentClient){
            currentClient = response.data[0]
          }
          this.setCurrentClient(currentClient)
          this.updateLogo(currentClient)
        }.bind(this))
        .catch((e) => console.log(e))
    },

    updateLogo (currentClient) {
      if (currentClient.id && currentClient.domain) {
        this.$http.get('/clients/' + currentClient.id, { params: {domain: currentClient.domain} })
          .then(function(response) {
            this.$refs.clientLogo.src = response.data.logo_url || '/img/SOKAL-Final-Color.png'
          }.bind(this))
          .catch((e) => console.log(e))
      }
    },

    updateDateRange (dateRange) {
      this.$store.commit('setStartDate', dateRange.startDate)
      this.$store.commit('setEndDate', dateRange.endDate)
      this.$eventBus.$emit('reloadWidgets')
    },

    updateCompareDateRange (dateRange) {
      this.$store.commit('setCompareStartDate', dateRange.startDate)
      this.$store.commit('setCompareEndDate', dateRange.endDate)
    },
    edit (action) {
      this.$store.commit('setWidgetsSettingsVisibility', action)
    },
    toggle (action) {
      this.$store.commit('toggleQuickDate', action)
    },
    checkMobile () {
      var contents = document.getElementsByClassName('app-body')
      if (contents[0].offsetTop === 55) {
        this.toggleSideNav = true
      }
    },
    ...mapActions([
      'getDashboards'
    ])
  }
}
</script>

<style scoped>
.border-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  width: 45%;
  max-width: 150px;
}
.borderless {
  border: 0;
  border-radius: 4px;
  text-align: center;
  width: 45%;
  max-width: 200px;
  background: transparent;
}
.borderless:active, .borderless:focus {
  border: 0;
  box-shadow: none;
  outline-color: transparent;
  outline-width: 0px;
  -webkit-tap-highlight-color: transparent;
}
#tablet-dropdown {
  position: fixed;
  top: 60px;
  right: 5px;
  z-index: 99999;
  background: #fff;
  border: transparent;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,.15);
}
#tablet-dropdown .card {
  margin-bottom: 0;
  border-radius: 0px;
  border: transparent;
}
#tablet-dropdown .card-body {
  margin-top: 0;
  padding: 10px 10px;
  overflow: visible;
}
.nav-icons {
  font-size: 34px;
  color: #a8a8a8;
  cursor: pointer;
}
.show-header-scroll {
  box-shadow: 0 1px 6px rgba(0, 0, 0, .1), inset 0 -1px 0 rgba(0,0,0,0.03)
}
.v-select {
  width: 20em
}
.main-header {
  padding: 25px 15px 15px;
  text-align: center;
}
.main-header:after {
  content: '';
  display: block;
  height: 1px;
  width: 60%;
  background: rgba(0,0,0,.15);
  margin: 5px auto 10px;
}
.edit-btn-container {
  display: inline-block;
  padding-left: 15px;
  -webkit-transform: translateY(-4px);
  transform: translateY(-4px);
}
.main-header h1 {
  display: inline-block;
}
.fixed-header {
  position: fixed;
  z-index: 100;
  background-color: #f5f5f5;
  width: 100%;
}
.head-space {
  height: 73px;
}
.edit-btn {
  color: #23282c;
  background: transparent;
  font-size: 24px;
  padding: 0px 5px;
  border: none;
}
.edit-btn-blue {
  color: #333;
  background: transparent;
  border: none;
}
.edit-btn-sm {
  padding: 0px;
  font-size: 24px;
  margin-left: 15px;
  line-height: 24px;
}
.edit-btn-blue:hover {
  color: #47889c;
}
.edit-btn:hover, .edit-btn:focus, .edit-btn:active, .edit-btn-sm:hover, .edit-btn-sm:focus, .edit-btn-sm:active {
  background: transparent !important;
  box-shadow: none !important;
}
#clientAlert {
	position: absolute;
  top: 60px;
  left: 25%;
	background: #ffffff;
	border: 4px solid #ff9696;
  padding: 7px 15px;
  font-size: 16px;
  border-radius: 4px;
}
#clientAlert:after, #clientAlert:before {
	bottom: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}
#clientAlert:after {
	border-color: rgba(255, 255, 255, 0);
	border-bottom-color: #ffffff;
	border-width: 10px;
	margin-left: -10px;
}
#clientAlert:before {
	border-color: rgba(245, 137, 137, 0);
	border-bottom-color: #ff9696;
	border-width: 16px;
	margin-left: -16px;
}
.compare-checkbox {
  margin-left: 5px;
}
#side-nav {
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease; 
}
#side-nav.closed {
  margin-left: -250px;
}
.main.closed {
  margin-left: 0;
}
@media (min-width: 768px) {
  .main-header:after {
    min-width: 300px;
  }
}
@import '~vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
</style>

<style>
.modal-dialog {
  margin-top: 70px;
}
@media (min-width: 768px) and (max-width: 1399px) {
  .daterangepicker.openscenter {
    left: auto !important;
  }
  .daterangepicker:before, .daterangepicker:after {
    display: none;
  }
}
@media(max-width: 767px){
  .navbar .nav-item.px-3 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .navbar .navbar-nav.ml-auto, .app{
    background: #fff;
  }
  .navbar-nav.mobile-client {
    position: absolute;
    left: 33%
  }
  .app-body .fixed-header {
    margin: 0;
  }
  .navbar-nav .selected-tag {
    position: absolute;
  }
  .mobile-client, .mobile-client .dropdown.searchable, .mobile-client .dropdown-toggle {
    width: 160px;
    height: 40px;
  }
  .navbar-brand, .navbar-brand > img {
    width: 50px !important;
  }
  .card-body {
    overflow: auto;
  }
  .head-space .fixed-header h1 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 1.6rem;
  }
  .head-space .fixed-header {
    height: inherit;
  }
  .card .card-header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .drp-calendar {
    display: block;
    width: 100vw;
    margin: 0 auto;
  }
  .daterangepicker .ranges li {
    display: inline-block;
  }
  .daterangepicker .calendars {
    display: block;
  }
  #default-container {
    padding: 0;
  }
  .border-input {
    max-width: 140px !important;
  }
  #date-collapse .form-control {
    padding: 0.375rem 0.3rem;
  }
}
.fixedCardHeader {
  /* position: fixed; */
  z-index: 10;
  width: calc(100% - 1px);
  border-right: 1px solid #c8ced3;
}
.card-body {
  margin-top: .5rem;
}
.card {
  border-radius: 6px;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,.15);
}
.card-header {
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}
.card, .vue-resizable-handle  {
  z-index: 11;
}
main.main {
  background-color: #9DACB1;
  margin-left: 250px;
  padding: 15px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease; 
}
.main-space {
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,.15);
  border-radius: 6px;
  padding: 15px 0;
}
h1#dashboard-title {
  font-family: 'Cooper Hewitt Medium';
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 1.25rem;
  color: #333;
}
.btn-primary, .badge-primary {
  color:#fff;
  background:#3493B2;
  border: 1px solid #3493B2;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.btn-primary:hover, .badge-primary:hover {
  background: #47889c;
  color: #fff;
  border: 1px solid #47889c;
}
.badge-danger {
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.badge-danger:hover {
  background-color: #f64846;
}
.modal-light .modal-header {
  color: #23282c;
}
.modal-footer {
  border-top: none;
}
.modal-light .modal-header:after {
  position: absolute;
  content: '';
  height: 1px;
  top: 44px;
  margin: 0;
  left: 15px;
  right: 0;
  width: 20%;
  background: #c4c4c4;
}
.modal-title {
  font-family: 'Cooper Hewitt Semibold';
  text-transform: uppercase;
  color: #3493B2;
  letter-spacing: 2px;
}
.modal-light .modal-header, .card-header {
  background: #fff;
  border-bottom: none;
}
.calendar-table i {
    padding: 0.5rem;
    display: inline-block;
}
.v-select .vs__selected-options {
  align-items: center;
  overflow: hidden;
}
.nav-item .v-select .selected-tag {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  flex: 1;
  flex-basis: 90%;
  text-align: left;
}
.navbar-brand {
  position: relative !important;
  margin-left: 0 !important;
  left: 0 !important;
}
.w-100 .form-control {
    border: 0;
}
table {
  border: none;
}
th {
  border-top-width: 0px !important;
  border-bottom-width: 1px !important;
  color: #3493b2;
  text-transform: uppercase;
  font-family: 'Cooper Hewitt Medium';
  letter-spacing: 2px;
}
td {
  border-top-width: 0px !important;
  font-family: 'Cooper Hewitt Book';
  letter-spacing: 1px;
}
.table tbody tr:nth-of-type(even) {
  background-color: #EFF7F9;
}
.table tbody tr:nth-of-type(odd) {
  background-color: #fff;
}
.table-container .table tbody tr:nth-of-type(odd) {
  background-color: #EFF7F9;
}
.table-container .table tbody tr:nth-of-type(even) {
  background-color: #fff;
}
.table-hover tbody tr:hover {
  background-color: #f5f5f5 !important;
}
table.b-table > thead > tr > th.sorting::before, table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::before, table.b-table > tfoot > tr > th.sorting::after {
  font-family: sans-serif;
  font-weight: 500;
}
table button {
  font-family: sans-serif;
}
table i {
  font-style: normal;
}
table strong {
  font-family: 'Cooper Hewitt Medium';
}
#toggle-button {
  position: fixed;
  bottom: 15px;
  left: 15px;
  z-index: 9999999999;
  border-radius: 100%;
  height: 45px;
  width: 45px;
  background: #3493b2;
  color: #EFF7F9;
  font-size: 25px;
  font-weight: 600;
  padding-left: 12px;
  padding-top: 4px;
  transition: all .5s ease;
  cursor: pointer;
  box-shadow: 2px 10px 30px rgba(0,0,0,.3);
}
#toggle-button.toggle-right {
  left: 175px;
}
#toggle-button.toggle-left {
  padding-left: 15px;
}
.modal-danger .modal-title {
  color: #fff;
}
@media (min-width: 1400px) {
  .lp-down {
    display: none;
  }
}
@media (max-width: 1399px) {
  .lp-up {
    display: none;
  }
}
@media (min-width: 992px) {
  .header-fixed .app-header {
    z-index: 999;
    display: none;
  }
  .header-fixed .app-body {
    margin-top: 0;
  }
}
@media (min-width: 1400px) {
  .header-fixed .app-header {
    z-index: 9999;
  }
}
.hide-export .edit-btn-blue {
  display: none !important;
}
</style>
